import { render, staticRenderFns } from "./sql-reference.vue?vue&type=template&id=2c891c8e"
import script from "./sql-reference.vue?vue&type=script&lang=js"
export * from "./sql-reference.vue?vue&type=script&lang=js"
import style0 from "./sql-reference.vue?vue&type=style&index=0&id=2c891c8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports